module.exports = __webpack_public_path__ + "985910d6401f678b3952b3fc1506fa6f.svg";